import { render, staticRenderFns } from "./Attraction.vue?vue&type=template&id=55ca7b6e&"
import script from "./Attraction.vue?vue&type=script&lang=js&"
export * from "./Attraction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports